var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.794434,
    y: 0.5,
    width: 25.0076,
    height: 25,
    rx: 12.5,
    fill: "#456786"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6316 14.333C18.5702 14.3757 17.2982 15.7217 17.2982 16.6663C17.2982 17.6623 17.9309 18.2983 18.6316 18.333C19.2356 18.3623 19.9649 17.739 19.9649 16.6663C19.9649 15.6663 18.6929 14.3757 18.6316 14.333ZM11.6889 18.333C11.9409 18.585 12.2756 18.7237 12.6316 18.7237C12.9876 18.7237 13.3222 18.585 13.5742 18.333L18.2409 13.6663L17.7696 13.195L12.6316 8.05699L11.1029 6.52832L10.1602 7.47099L11.6889 8.99965L7.96489 12.7237C7.71289 12.9757 7.57422 13.3103 7.57422 13.6663C7.57422 14.0223 7.71289 14.357 7.96489 14.609L11.6889 18.333ZM12.6316 9.94232L16.3556 13.6663H8.90755L12.6316 9.94232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.17de42e746517c4a57c2af35248bf15b.svg";
export { ForwardRef as ReactComponent };